'use strict';

import raven from 'raven';
import angular from 'angular';
import SimpleMessages from '../../controllers/simple-messages';
import NewVehicleController from '../quote/new-vehicle.controller';
import NewVehicleTpl from '../quote/new-vehicle.html';

import AddQuotesToGroupInvoiceController from './add-quotes-to-group-invoice.controller';
import AddQuotesToGroupInvoiceTpl from './add-quotes-to-group-invoice.html';

class QuotesController {
  /* @ngInject */
  constructor(
    QuotesService,
    ClientsService,
    VehiclesService,
    OrderTranslationService,
    ProcedureTemplatesService,
    GroupInvoicesService,
    $scope,
    $q,
    $mdDialog,
    $mdToast
  ) {
    Object.assign(this, {
      QuotesService,
      ClientsService,
      VehiclesService,
      OrderTranslationService,
      ProcedureTemplatesService,
      GroupInvoicesService,
      $scope,
      $q,
      $mdDialog,
      $mdToast
    });

    this.query = {
      where: {},
      limit: 50,
      page: 1,
      order: 'createdAt DESC',
      include: [
        'holder',
        'vehicle',
        'groupInvoice',
        {
          relation: 'procedures',
          scope: {
            order: 'id ASC',
            limit: 1
          }
        },
        'createdByUser'
      ]
    };

    this.getQuotes();
    this.onPagination = () => {
      this.getQuotes();
    };
    this.onReorder = () => {
      this.getQuotes();
    };

    this.selectedQuotesClientId = null;
    this.selectedQuotes = {};
  }

  onClientFilterUpdate($event) {
    let clientsPromise = $event.clientsPromise;
    clientsPromise.then(clients => {
      this.clientIds = clients ? clients.map(c => c.id) : null;
      this.getQuotes();
    });
  }

  onHolderFilterUpdate($event) {
    let clientsPromise = $event.clientsPromise;
    clientsPromise.then(clients => {
      this.holderIds = clients ? clients.map(c => c.id) : null;
      this.getQuotes();
    });
  }

  getQuotes() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    // Order translation
    if (this.mdOrder) {
      qOpts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    if (this.id) {
      this.holder = null;
      this.vehicle = null;
      this.procedureTemplate = null;
      qOpts.where = Object.assign(qOpts.where, {
        id: this.id
      });
    }

    if (this.holderIds) {
      qOpts.where = Object.assign(qOpts.where, {
        holderId: {
          inq: this.holderIds
        }
      });
    }

    if (this.clientIds) {
      qOpts.where = Object.assign(qOpts.where, {
        clientId: {
          inq: this.clientIds
        }
      });
    }

    if (this.vehicle) {
      Object.assign(qOpts.where, {
        vehicleId: this.vehicle.id
      });
    }

    if (this.procedureTemplate) {
      Object.assign(qOpts.where, {
        procedureName: this.procedureTemplate.name
      });
    }

    if (this.onlyApproved) {
      qOpts.where = Object.assign(qOpts.where, {
        approvedAt: {
          neq: null
        }
      });
    }

    if (this.pendingAmount > 0) {
      qOpts.where = Object.assign(qOpts.where, {
        totalPendingAmount: {
          gte: this.pendingAmount
        }
      });
    }
    if (this.pendingReceiptsAmount > 0) {
      qOpts.where = Object.assign(qOpts.where, {
        totalPendingCollectionAmount: {
          gte: this.pendingReceiptsAmount
        }
      });
    }
    if (this.pendingInvoicesAmount > 0) {
      qOpts.where = Object.assign(qOpts.where, {
        totalPendingInvoicesAmount: {
          gte: this.pendingInvoicesAmount
        }
      });
    }
    if (this.groupInvoiceStatus != 'all') {
      qOpts.where = Object.assign(qOpts.where, {
        groupInvoiceStatus: this.groupInvoiceStatus
      });
    }

    this.promise = this.QuotesService.getModels(qOpts).then(res => {
      this.quotes = res.result.quotes;
      this.quotesCount = res.result.count;
    });
    return this.promise;
  }

  querySearchClient(text) {
    return this.ClientsService.find({
      filter: {
        where: {
          or: [
            {
              name: {
                ilike: `%${text}%`
              }
            },
            {
              lastName: {
                ilike: `%${text}%`
              }
            }
          ]
        },
        order: 'lastName DESC, name DESC'
      }
    });
  }

  queryVehicleSearch() {
    return this.VehiclesService.getModels({
      where: {
        broad: this.searchVehicleText
      },
      order: 'plate DESC, number DESC, description DESC'
    }).then(vehicles => {
      return vehicles.map(v => {
        v.fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
        return v;
      });
    });
  }

  queryProcedureSearch() {
    return this.ProcedureTemplatesService.getModels({
      where: {
        name: {
          ilike: `%${this.searchProcedureTemplateText}%`
        }
      },
      order: 'name DESC'
    });
  }

  newVehicle(ev, initialPlate) {
    this.searchVehicleText = '';
    this.$mdDialog
      .show({
        controller: NewVehicleController,
        template: NewVehicleTpl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: this.$scope.customFullscreen,
        locals: {
          initialPlate: initialPlate,
          VehiclesService: this.VehiclesService
        }
      })
      .then(data => {
        this.showNewVehicleSpin = true;
        let newVehicle = this.VehiclesService.create(data.vehicle);
        return this.VehiclesService.save(newVehicle);
      })
      .then(vehicle => {
        // AGAIN MF fullDesc HACK
        vehicle.fullDesc = `${vehicle.plate} - ${vehicle.number} - \
${vehicle.description}`;
        this.simpleSuccess(`El nuevo vehiculo ha sido creado
 correctamente`);
        this.showNewVehicleSpin = false;
      });
  }

  getClientName(client) {
    return client.lastName + ' ' + client.name;
  }

  onToggleQuote(quote) {
    if (
      this.selectedQuotesClientId &&
      this.selectedQuotesClientId == quote.clientId
    ) {
      let someSelected =
        Object.keys(this.selectedQuotes)
          .map(id => this.selectedQuotes[id])
          .filter(v => v).length > 0;
      if (!someSelected) {
        this.selectedQuotesClientId = null;
      }
    } else {
      this.selectedQuotesClientId = quote.clientId;
      this.selectedQuotes[quote.id] = true;
    }
  }

  addQuotesToGroupInvoice(ev) {
    let quoteIds = Object.keys(this.selectedQuotes);
    let groupInvoicesP = this.GroupInvoicesService.find({
      filter: {
        where: {
          clientId: this.selectedQuotesClientId
        },
        order: 'date DESC',
        limit: 5
      }
    });
    this.$mdDialog
      .show({
        controller: AddQuotesToGroupInvoiceController,
        template: AddQuotesToGroupInvoiceTpl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          quoteIds: quoteIds,
          groupInvoicesP: groupInvoicesP
        }
      })
      .then(data => {
        if (!data.groupInvoice) return;
        this.showAddQuotesToGroupInvoiceSpin = true;
        this.GroupInvoicesService.addQuotes({
          quoteIds: quoteIds,
          groupInvoiceId: data.groupInvoice.id
        }).then(
          res => {
            this.showAddQuotesToGroupInvoiceSpin = false;
            this.simpleSuccess();
            this.selectedQuotesClientId = null;
            this.selectedQuotes = {};
            quoteIds.forEach(quoteId => {
              let quote = this.quotes.find(q => q.id == quoteId);
              quote.groupInvoiceId = res.groupInvoice.id;
            });
          },
          err => {
            this.showAddQuotesToGroupInvoiceSpin = false;
            this.simpleError();
            raven.captureException(err);
          }
        );
      });
  }

  getInvoices(quote) {
    return quote.invoicesList.map(i => i.number).join(', ');
  }
}

Object.assign(QuotesController.prototype, SimpleMessages);

export default QuotesController;
